import getYouTubeID from "get-youtube-id";
import React from "react";
import { FormattedMessage } from "react-intl";
import YouTube from "react-youtube";
import { useParams } from "react-router-dom";
import {
  CallToAction,
  ContactInfo,
  ContentProduct,
  Layout,
  Newsletter,
} from "../components";
import { useCompany } from "../redux/hooks/hooks";
import PageHero from "../components/common/PageHero";
import SectionHeader from "../components/common/SectionHeader";

const Company = () => {
  const { slug } = useParams(); // Accept slug parameter for consistency
  const data = useCompany();
  const onReady = (event) => {
    event.target.pauseVideo();
  };
  return (
    <Layout data={data}>
      <PageHero
        eyebrow="Africa Systems"
        title={data?.hero?.title}
        description={data?.hero?.description}
        image={data?.hero?.image}
      />
      <div className="pt-2 pb-24 bg-white">
        <div className="max-w-[1400px] mx-auto px-5 sm:px-8 lg:px-12">
          <div className="flex flex-col md:flex-row w-full gap-8 lg:gap-12">
            <div className="w-full md:w-2/3 pt-8">
              <ContentProduct />
              <div className="py-8">
                <SectionHeader eyebrow="Africa Systems" title={<FormattedMessage id="videos" />} />
                <div className="grid grid-cols-1 md:grid-cols-2 pt-4 gap-4">
                  {data?.videos?.map((video, index) => (
                    <div key={index} className="w-full">
                      <YouTube
                        videoId={`${getYouTubeID(video)}`}
                        onReady={onReady}
                        iframeClassName="w-full h-[12rem] md:h-[10rem]"
                      />
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div className="w-full md:w-1/3">
              <ContactInfo />
              <div className="flex justify-center pt-8">
                <CallToAction />
              </div>
              <div className="pt-8 md:px-2">
                <Newsletter />
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Company;